import qwest from 'qwest';
import {AlexPROSpecialArticlesTypes}  from 'helpers/constants';

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = (err) => {
  console.error("API error");
  console.error(err);
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let EncyclopediaApi = {
  search(search, from, to, page) {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/Search?search=${search}&from=${from}&to=${to}&page=${page}`)
        .then(onSuccess(), onError);
  },
  getArticleFromEncyclopedia(id) {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetArticle?id=${id}`)
        .then(onSuccess(), onError);
  },
  encyclopediaWelcomePage(locale = 'en-US') {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetSpecialArticle?type=${AlexPROSpecialArticlesTypes.Encyclopedia_WelcomePage}&locale=${locale}`)
        .then(onSuccess(), onError);
  },
  getPrivacyPolicy(locale = 'en-US') {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetSpecialArticle?type=${AlexPROSpecialArticlesTypes.PrivacyPolicy}&locale=${locale}`)
        .then(onSuccess(), onError);
  },
  getTermsOfService(locale = 'en-US') {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetSpecialArticle?type=${AlexPROSpecialArticlesTypes.TermsOfService}&locale=${locale}`)
        .then(onSuccess(), onError);
  },
  alexPROWelcomePage(locale = 'en-US') {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetSpecialArticle?type=${AlexPROSpecialArticlesTypes.AlexPRO_WelcomePage}&locale=${locale}`)
        .then(onSuccess(), onError);
  },
  getFolders() {
    return qwest.get('v1/shelfIntegration/Encyclopedia/GetFolders')
      .then(onSuccess(), onError);
  },
  getFolderContents(path) {
    return qwest.get(`v1/shelfIntegration/Encyclopedia/GetFolderContents?path=${path}`)
      .then(onSuccess(), onError);
  },
};

export default EncyclopediaApi;